import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import * as Sentry from '@sentry/react';

import { searchScaleDevices } from 'api/admin/scaleDevices/scaleDevices';
import TableSearchBar from 'components/common/search/TableSearchBar';
import { CentsDataGrid } from 'components/common/dataGrid/dataGrid';

const COLUMNS = [
  { header: 'ID', field: 'id', sortable: false, flex: 0.5 },
  { header: 'Pin Number', field: 'pinNumber', sortable: false, flex: 1 },
  { header: 'Device UUID', field: 'deviceUuid', sortable: false, flex: 1 },
  { header: 'Store Name', field: 'storeName', sortable: false, flex: 1 },
];

const ScaleDevicesTable = () => {
  const history = useHistory();
  const [searchInput, setSearchInput] = useState('');

  const { data, isLoading } = useQuery(
    ['searchScaleDevices', { searchInput }],
    async () => {
      const { data } = await searchScaleDevices(searchInput);
      return {
        scaleDevices: data.scaleDevices,
        scaleDeviceCount: data.total,
      };
    },
    {
      onError: (error) => {
        // maintaining existing error handling behavior
        console.log(error);
        Sentry.captureException(error);
      },
    },
  );
  const { scaleDevices, scaleDeviceCount } = data ?? {};

  const handleAddScaleDeviceClick = () => {
    history.push('/scale-devices/new');
  };

  const handleRowClick = ({ id }) => {
    history.push(`/scale-devices/${Number(id)}`);
  };

  const handleSearch = (searchInput) => {
    setSearchInput(searchInput);
  };

  return (
    <div className="page-container">
      <div className="scale-devices-header">
        <h1>Scale Devices</h1>
        <button className="create-scale-device-button" onClick={handleAddScaleDeviceClick}>
          Add Scale Device
        </button>
      </div>
      <div className="scale-device-search-bar">
        <TableSearchBar placeholder="Find a scale device" onSearch={handleSearch} />
      </div>
      {scaleDeviceCount && scaleDeviceCount > 0 ? (
        <CentsDataGrid
          tableName="SCALE_DEVICES"
          data={scaleDevices}
          columns={COLUMNS}
          onRowClick={handleRowClick}
          isLoading={isLoading}
        />
      ) : (
        <p>No scale devices have been registered</p>
      )}
    </div>
  );
};

export default ScaleDevicesTable;
